"use client";

import { DayPicker, type DateRange } from "react-day-picker";
import { enUS } from "react-day-picker/locale";
import "react-day-picker/style.css";
import { dateToIso, isoToLocalDate } from "../lib/isoDate";

/** Inclusive calendar-date range as ISO yyyy-mm-dd strings; `end` is unset while mid-selection. */
export interface IsoDateRange {
  start: string;
  end?: string;
}

interface DateRangeCalendarProps {
  value?: IsoDateRange;
  onRangeSelect: (range?: IsoDateRange) => void;
  className?: string;
}

/** Month calendar for picking an inclusive date range (click start, then end). */
export function DateRangeCalendar({
  value,
  onRangeSelect,
  className,
}: DateRangeCalendarProps) {
  const selected: DateRange | undefined = value
    ? {
        from: isoToLocalDate(value.start),
        to: value.end ? isoToLocalDate(value.end) : undefined,
      }
    : undefined;

  return (
    <DayPicker
      mode="range"
      locale={enUS}
      selected={selected}
      onSelect={(range) => {
        if (!range?.from) {
          onRangeSelect(undefined);
          return;
        }
        onRangeSelect({
          start: dateToIso(range.from),
          end: range.to ? dateToIso(range.to) : undefined,
        });
      }}
      className={className}
    />
  );
}
